import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import Storage from "@/app/core/util/Storage";
import React, { useEffect, useState } from "react";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { MoneyMask, ProcessCurrency, ProcessValue, ValueType } from "@/app/core/util/helpers/MoneyHelper";

export default function QuotationItem({ item, reportValue, selectInternactional, index }) {
    const [userData, setUserData] = useState(Storage.getUserData());
    const [data, setData] = useState({});

    useEffect(() => {
        setData(item);
    }, [item])

    function handleChange(evt, type) {
        let newData = OnDataChange(data, evt, type);
        if (evt.target.name == "editedPercentage") {
            let baseValue = data.freight_final;
            const result = baseValue + (baseValue * evt.target.value / 100)
            newData.customTotalPrice = result;
        }
        setData(newData);
    }

    function preReport() {
        // console.log("Versão", data.customTotalPrice, data.freight_final, data)
        // if (data.customTotalPrice < data.freight_final) {
        //     toast.error(Translate(Message.CantBeLessThanCost));
        //     return;
        // } else {
        toast.success(Translate(Message.Saved))
        reportValue(data);

        // }
    }

    return (
        <div className="block block-rounded block-fx-pop mb-2 js-appear-enabled animated fadeIn mb-3 mt-3" style={{ zIndex: 99999999999999999999999999 }} data-toggle="appear">
            <div className="block-content block-content-full border-left border-3x border-success">
                <div className="d-md-flex justify-content-md-between align-items-md-center">
                    <div className="p-1 p-md-3">
                        <h3 className="h4 font-w700 mb-1">{item.name}</h3>
                        <p className="font-size-sm text-muted mb-0">
                            {Translate(Message.DeliveryDate)} {" "}
                            {item && item.transit_days}  {Translate(Message.Days)} <br />
                            {item && item.tax_final != undefined ? `Impostos: ${ProcessCurrency()}${MoneyMask(item.tax_final, 2)}` : ""}
                        </p>
                    </div>
                    <div className="p-1 p-md-3 d-md-flex justify-content-md-between align-items-md-center">
                        <a className="btn btn-outline-secondary btn-rounded px-3 mr-1 my-1" href="javascript:void(0)">
                            {ProcessCurrency()}{data && MoneyMask(data.customTotalPrice, 2)}
                        </a>
                        <button className="btn btn-outline-success btn-rounded px-3 my-1" onClick={() => selectInternactional(item)}>
                            <i className="si si-check mr-1"></i>  {Translate(Message.Advance)}
                        </button>
                        {userData && userData.role > 0 ?
                            <Dropdown drop="up"
                                alignEnd={"bottom-start"}>
                                <Dropdown.Toggle variant="light">
                                    <i className="si si-settings" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu style={{ zIndex: 99999999999999999999999999, width: 340 }}>
                                    <div className="form-group">
                                        <label className="d-block">Tipo de valor</label>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" className="custom-control-input"
                                                id={"valueType" + index}
                                                name={"valueType" + index}
                                                checked={data && data.valueType == ValueType.Value ? true : false}
                                                onChange={evt => setData({ ...data, valueType: ValueType.Value })}
                                            />
                                            <label className="custom-control-label" htmlFor={"valueType" + index}>Valor</label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input type="radio" className="custom-control-input"
                                                id={"percentageType" + index}
                                                name={"valueType" + index}
                                                checked={data && data.valueType == ValueType.Percentage ? true : false}
                                                onChange={evt => setData({ ...data, valueType: ValueType.Percentage })}
                                            />
                                            <label className="custom-control-label" htmlFor={"percentageType" + index}>Porcentagem</label>
                                        </div>
                                    </div>
                                    {data && data.valueType == ValueType.Value ?
                                        <div className="form-group">
                                            <span>Valor do frete</span>
                                            <input type="number" className="form-control" value={data && data.customTotalPrice} name="customTotalPrice" onChange={evt => handleChange(evt, FieldTypeObj.Currency)} />
                                        </div>
                                        : ""}
                                    {data && data.valueType == ValueType.Percentage ?
                                        <div className="form-group">
                                            <span>Porcentagem de margem</span>
                                            <input type="number" className="form-control" value={data && data.editedPercentage} name="editedPercentage" onChange={evt => handleChange(evt, FieldTypeObj.Currency)} />
                                            <br />
                                            <span>Valor do frete</span>
                                            <br />
                                            {ProcessCurrency()}{data && MoneyMask(data.customTotalPrice, 2)}
                                        </div>
                                        : ""}

                                    <button className="btn btn-block btn-success" onClick={() => preReport()}>Registrar</button>
                                </Dropdown.Menu>
                            </Dropdown>
                            : ""}
                    </div>
                </div>
            </div>
        </div>
    )
}